import React from 'react';
import { motion } from 'framer-motion';

interface MechanicalCounterProps {
  value: number;
}

const MechanicalCounter: React.FC<MechanicalCounterProps> = ({ value }) => {
  const digits = String(value).split('').map(Number);

  return (
    <div className="flex items-center justify-center p-2 bg-black/50 rounded-lg">
      {digits.map((digit, index) => (
        <div key={index} className="relative w-8 h-12 overflow-hidden bg-gray-800 rounded-md shadow-inner">
          <motion.div
            className="absolute inset-0 flex flex-col items-center justify-center text-4xl font-bold text-white"
            animate={{ y: `-${digit * 10}%` }}
            transition={{ duration: 0.5, ease: 'easeInOut' }}
          >
            {Array.from({ length: 10 }).map((_, i) => (
              <div key={i} className="h-full flex items-center justify-center">
                {i}
              </div>
            ))}
          </motion.div>
        </div>
      ))}
    </div>
  );
};

export default MechanicalCounter;
